import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class OrderListService {

  private apiUrl = globalConst.baseAPI;  // URL para web api

	/**
	* Método construtor
	* @param http: Http
	*/
	constructor(private http: Http) { }

  getOrders(token, orderby, documento, numero, sort, page) {

		page = page * globalConst.paginationSkip;

		return this.http
			.get(this.apiUrl + "/order/v1/getlist?$orderby=" + orderby + " " + sort + "&$top="+globalConst.paginationSkip+"&$skip=" + page + "&$filter=startswith(tolower(Documento),'" + documento.toLowerCase() + "') and startswith(tolower(Numero), '" + numero.toLowerCase() + "')", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
  }

}



// WEBPACK FOOTER //
// ./src/app/order/service/order-list/order-list.service.ts